import styled from 'styled-components';

import MotifCard from '@ey/motif-react-wrapper/Card';

export default styled(MotifCard)`
	display: flex;
	flex-direction: column;
	width: unset;

	&.card-background,
	&.motif-card-orientation-vertical {
		padding: var(--spacing-x-large);
		gap: var(--spacing-x-large);
	}
`;
